import styled from 'styled-components'
import { flexbox, space, FlexboxProps, SpaceProps } from 'styled-system'

import { WithChild } from 'utils'

export const CenterDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const FlexDiv = styled.div<FlexboxProps & SpaceProps & WithChild>`
  display: flex;
  ${flexbox};
  ${space};
`

export const AbsoluteCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
